import FJImageManipulationRight from './FJImageManipulationRight';

import { useDispatch } from 'react-redux';
import { setSliceIsDraggingFileAction } from '../../../redux/slices/FJSliceCommon';
import FJActionImageManipulation from '../../../redux/action/FJActionImageManipulation';
import useLocalStore from '../../../hooks/useLocalStore';
import { useSelector } from 'react-redux';

const FJImageManipulationRightContainer = () => {
    useLocalStore();

    const dispatch = useDispatch();
    const headerTabIndex = useSelector(state => state.common.headerTabIndex);
    const taskStatus = useSelector(state => state.common.taskStatus);
    const downloadEditImageLoading = useSelector(state => state.imageManipulation.downloadEditImageLoading);
    const hasEditImage = useSelector(state => {
        const editImage = state.brushEditCommon.editImage;
        return editImage && editImage.src && editImage.src !== ''
    });
    const isCanDownload = useSelector(state => {
        const { editImage, originImage } = state.brushEditCommon;
        return originImage && editImage && originImage.src !== editImage.src;
    });

    const uploadImg = file => {
        dispatch(FJActionImageManipulation.uploadImageAction(file));
    };
    const _setIsDraggingFile = value => {
        dispatch(setSliceIsDraggingFileAction(value));
    };

    const download = () => {
        dispatch(FJActionImageManipulation.downloadEditImageAction());
    };

    return (
        <FJImageManipulationRight
            uploadImg={uploadImg}
            setIsDraggingFile={_setIsDraggingFile}
            headerTabIndex={headerTabIndex}
            taskStatus={taskStatus}
            downloadEditImageLoading={downloadEditImageLoading}
            download={download}
            isCanDownload={isCanDownload}
            hasEditImage={hasEditImage}
        />
    );
};
export default FJImageManipulationRightContainer;
